import { render } from "./BorderInputPhone.vue?vue&type=template&id=b1a9df58&scoped=true"
import script from "./BorderInputPhone.vue?vue&type=script&lang=js"
export * from "./BorderInputPhone.vue?vue&type=script&lang=js"

import "./BorderInputPhone.vue?vue&type=style&index=0&id=b1a9df58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1a9df58"

export default script